import React, { useEffect, useState } from 'react';
import {
  CAPTION_CONFIRM_EVENT,
  captionConfirmCopy,
  resolveCaptionConfirm,
} from '../../utils/voiceTaskCommands';

const CaptionActionConfirmHost = () => {
  const [action, setAction] = useState(null);

  useEffect(() => {
    const onAsk = (event) => setAction(event.detail || null);
    window.addEventListener(CAPTION_CONFIRM_EVENT, onAsk);
    return () => window.removeEventListener(CAPTION_CONFIRM_EVENT, onAsk);
  }, []);

  if (!action) return null;

  const copy = captionConfirmCopy(action);
  const close = (ok) => {
    setAction(null);
    resolveCaptionConfirm(ok);
  };

  return (
    <div className="fixed inset-0 z-[2200] overflow-y-auto">
      <div
        className="fixed inset-0 bg-black/50"
        onClick={() => close(false)}
      />
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative w-full max-w-md rounded-lg bg-white shadow-xl dark:bg-gray-800">
          <div className="border-b border-gray-200 px-6 py-4 dark:border-gray-700">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              {copy.title}
            </h3>
          </div>
          <div className="px-6 py-5">
            <p className="text-sm text-gray-600 dark:text-gray-300">
              {copy.message}
            </p>
          </div>
          <div className="flex justify-end gap-3 border-t border-gray-200 px-6 py-4 dark:border-gray-700">
            <button
              type="button"
              onClick={() => close(false)}
              className="rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200"
            >
              Not now
            </button>
            <button
              type="button"
              onClick={() => close(true)}
              className="rounded-lg bg-sky-600 px-4 py-2 text-sm font-medium text-white hover:bg-sky-700"
            >
              {copy.confirm}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaptionActionConfirmHost;
